import ServicePageTemplate from "@/components/ServicePageTemplate";
import { Search } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function SEO() {
  usePageMeta({
    title: "קידום אורגני SEO: בניית אסטרטגיה מנצחת לתוצאות בשטח | upsite",
    description: "תנו ללקוחות למצוא אתכם. אסטרטגיית ה-SEO של upsite משלבת מחקר עומק ואופטימיזציה חכמה לדירוג גבוה בגוגל לאורך זמן. לחצו לשיחת ייעוץ והתחילו לצמוח",
  });

  return (
    <ServicePageTemplate
      icon={Search}
      title="קידום אורגני בגוגל (SEO)"
      subtitle="קידום אורגני"
      description="אנחנו מתמחים בקידום אורגני שמביא תוצאות אמיתיות – יותר חשיפה, יותר תנועה, יותר לידים. עם אסטרטגיה מקצועית ותהליך עבודה מוכח."
      image="/images/services/seo.jpeg"
      benefits={[
        "מחקר מילות מפתח ובניית אסטרטגיית תוכן",
        "אופטימיזציה טכנית, מהירות, מבנה והיררכיה",
        "בניית פרופיל קישורים חכם ואמין",
        "מעקב, מדידה ושיפור מתמיד",
        "דיווחים שקופים ומפורטים",
        "התאמה לעדכוני האלגוריתם של גוגל",
      ]}
      processSteps={[
        { title: "אבחון ומחקר", desc: "ניתוח מעמיק של האתר, המתחרים ומילות המפתח הרלוונטיות." },
        { title: "בניית אסטרטגיה", desc: "תוכנית פעולה מפורטת שכוללת תוכן, טכניקה וקישורים." },
        { title: "יישום ואופטימיזציה", desc: "ביצוע השינויים הנדרשים באתר ובניית תוכן ממוקד." },
        { title: "מעקב ושיפור", desc: "מדידת תוצאות, התאמת האסטרטגיה ושיפור מתמיד." },
      ]}
    />
  );
}
